const FeatureFlagsCommonExtension = 'featureFlagsCommon';
export { FeatureFlagsCommonExtension };
